// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import mentorEntity from './entities/mentor.json';
import mentorMenu from '../pages/mentor/menu.json';
import mentorFullForm from '../pages/mentor/forms/full.json';
import mentorContextForm from '../pages/mentor/forms/context.json';
import mentorMiniForm from '../pages/mentor/forms/mini.json';
import mentorLookupForm from '../pages/mentor/forms/lookup.json';
import mentorTableView from '../pages/mentor/views/table.json';
import mentorStagesView from '../pages/mentor/views/stages.json';
import mentorCardsView from '../pages/mentor/views/cards.json';
import mentorInlineView from '../pages/mentor/views/inline.json';
import mentorBacklogView from '../pages/mentor/views/backlog.json';
import mentorSplitView from '../pages/mentor/views/split.json';
import mentorCalendarView from '../pages/mentor/views/calendar.json';
import mentorDashboardView from '../pages/mentor/views/dashboard.json';

/** Тип запису «Менторська пара» зі сторінками пакета: меню, форми та подання з pages/mentor/. */
export const mentorDefinition: IRecordTypeDefinition = {
  ...mentorEntity,
  views: assembleViewSet({
      table: mentorTableView,
      stages: mentorStagesView,
      cards: mentorCardsView,
      inline: mentorInlineView,
      backlog: mentorBacklogView,
      split: mentorSplitView,
      calendar: mentorCalendarView,
      dashboard: mentorDashboardView,
  }),
  form: mentorFullForm,
  forms: { full: mentorFullForm, context: mentorContextForm, mini: mentorMiniForm, lookup: mentorLookupForm },
  menu: mentorMenu,
} as IRecordTypeDefinition;
